import { LoginCallback } from '@okta/okta-react';
import { RouteObject } from 'react-router-dom';

import App from '../App';
import { Loading } from '../components/progress';
import APP_ENV from '../configs/appEnv';
import { Dashboard } from '../views/dashboard';
import { DashBoardCardView } from '../views/dashboard/components/contentGrid/cardView';
import { DetailView } from '../views/dashboard/components/contentGrid/detailView';
import { FacilityProvider } from '../views/dashboard/contexts/FacilityProvider';
import { ErrorPage } from '../views/error';
import { dashboardLoader } from './../views/dashboard/Dashboard';
import RequiredAuth from './SecureRoute';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <App />,
    errorElement: <ErrorPage />,
    children: [
      /********PUBLIC ROUTES**************/
      {
        path: APP_ENV.OKTA_REDIRECT_END_POINT,
        element: <LoginCallback loadingElement={<Loading />} />,
      },
      /***********************************/

      /*******PROTECTED ROUTES*************/
      {
        id: 'root',
        path: '/',
        element: <RequiredAuth />,
        children: [
          {
            errorElement: <ErrorPage />,
            children: [
              {
                id: 'dashboard',
                path: '/',
                element: (
                  <FacilityProvider>
                    <Dashboard />
                  </FacilityProvider>
                ),
                loader: dashboardLoader,
                children: [
                  {
                    errorElement: <ErrorPage />,
                    index: true,
                    element: <DashBoardCardView />,
                  },
                  {
                    errorElement: <ErrorPage />,
                    path: '/:graphId',
                    element: <DetailView />,
                  },
                ],
              },
              {
                path: '*',
                element: <ErrorPage />,
              },
            ],
          },
        ],
      },
      /*************************************/
    ],
  },
];

export default routes;
